// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TreeSunlightFoliage__leafSprite___dINJF {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    pointer-events: none;
    filter: saturate(1.1) brightness(0.92) blur(0.08px);
    opacity: var(--leaf-opacity);
    transform-origin: 50% 65%;
    will-change: transform;
    animation-play-state: running !important;
    animation: TreeSunlightFoliage__leafSpriteSway___W2Kg2 var(--leaf-duration) ease-in-out var(--leaf-delay) infinite;
}

@keyframes TreeSunlightFoliage__leafSpriteSway___W2Kg2 {
    0%, 100% {
        transform: translate3d(-50%, -50%, 0)
            translate3d(calc(var(--leaf-sway-x) * -0.75), calc(var(--leaf-sway-y) * 0.35), 0)
            rotate(calc(var(--leaf-rotation) - 0.08rad)) scale(0.98, 1.01);
    }
    23% {
        transform: translate3d(-50%, -50%, 0)
            translate3d(calc(var(--leaf-sway-x) * -0.1), calc(var(--leaf-sway-y) * -0.7), 0)
            rotate(calc(var(--leaf-rotation) + 0.02rad)) scale(1.01, 0.99);
    }
    51% {
        transform: translate3d(-50%, -50%, 0)
            translate3d(var(--leaf-sway-x), var(--leaf-sway-y), 0)
            rotate(calc(var(--leaf-rotation) + 0.11rad)) scale(1.02, 0.98);
    }
    77% {
        transform: translate3d(-50%, -50%, 0)
            translate3d(calc(var(--leaf-sway-x) * 0.3), calc(var(--leaf-sway-y) * -0.25), 0)
            rotate(calc(var(--leaf-rotation) - 0.03rad)) scale(0.99, 1.01);
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leafSprite": `TreeSunlightFoliage__leafSprite___dINJF`,
	"leafSpriteSway": `TreeSunlightFoliage__leafSpriteSway___W2Kg2`
};
module.exports = ___CSS_LOADER_EXPORT___;
